import React from 'react';

import {ConfirmModal} from '@components/Utils/ConfirmModal';

export const LockLootsheetModal: React.FC<{
	onSubmit(): Promise<void>;
	onClose(): void;
}> = (props) => {
	const [isSubmitting, setIsSubmitting] = React.useState(false);

	async function handleSubmit() {
		setIsSubmitting(true);

		await props.onSubmit();

		setIsSubmitting(false);
		props.onClose();
	}

	return (
		<ConfirmModal
			onSubmit={handleSubmit}
			onClose={props.onClose}
			isSubmitting={isSubmitting}
			heading="Lock lootsheet"
			submitColour="red"
			submitButtonText="Lock"
		>
			<p>
				Are you sure you want to lock this lootsheet to prevent it from being edited?
			</p>

			<p>Guild admins will still be able to make edits to the lootsheet</p>
		</ConfirmModal>
	);
};

export const UnlockLootsheetModal: React.FC<{
	onSubmit(): Promise<void>;
	onClose(): void;
}> = (props) => {
	const [isSubmitting, setIsSubmitting] = React.useState(false);

	async function handleSubmit() {
		setIsSubmitting(true);

		await props.onSubmit();

		setIsSubmitting(false);
		props.onClose();
	}

	return (
		<ConfirmModal
			onSubmit={handleSubmit}
			onClose={props.onClose}
			isSubmitting={isSubmitting}
			heading="Unlock lootsheet"
			submitColour="red"
			submitButtonText="Unlock"
		>
			Are you sure you want to unlock this lootsheet to enable editing?
		</ConfirmModal>
	);
};
